//import { WagmiProvider, createConfig, configureChains  } from 'wagmi'

import { WagmiProvider, http, createConfig } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { mainnet, base, goerli } from 'wagmi/chains'
//import { alchemyProvider } from 'wagmi/providers/alchemy'
//import { publicProvider } from 'wagmi/providers/public'
//import { jsonRpcProvider } from '@wagmi/core/providers/jsonRpc'
//import { InjectedConnector } from 'wagmi/connectors/injected'
import {useEffect} from 'react'
import { Buffer } from "buffer";
import React from 'react';

import FrontPage from './components/FrontPage'
//import AccountPage from './components/AccountPage'
import {chain} from './components/Config'

import './App.css';
//import './fonts/Chakra/ChakraPetch-Medium.ttf';

import GlobalStyle from './style/GlobalStyle'

import {
  createBrowserRouter,
  RouterProvider,
  useParams 
} from "react-router-dom";

window.Buffer = window.Buffer || Buffer;
 

/*
 const { chains, publicClient, webSocketPublicClient  } = configureChains(
  [chain],
  [
    //alchemyProvider({ apiKey: process.env.REACT_APP_ALCHEMY_API_KEY }),
    //publicProvider(),

    jsonRpcProvider({
      rpc: (chain) => ({
        http: chain.rpcUrls.public.http[0],
        //http: "https://rpc.ankr.com/blast_testnet_sepolia/13bc3e5c2b4ca20f87bf24426fde9530951c2ee4b658c542f919396d3ffb90f1",
      }),
    }),

  ],
)
*/
const config = createConfig({

  chains: [chain], 
  transports: { 
    [chain.id]: http(), 
    //[sepolia.id]: http(), 
  }, 

//  autoConnect: true,
//  publicClient,
//  connectors: [new InjectedConnector({ chains })],
//  webSocketPublicClient
})


const router = createBrowserRouter([
  {
    path: "/",
    element: <FrontPage/>,
  },

  /*{
    path: "/account",
    element: <AccountPage/>,
  }*/

  /*{
    path: "*",
    element: <ErrorPage />,
  },*/
]);

const queryClient = new QueryClient();

function App() {
  return (

    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <GlobalStyle />
        <RouterProvider router={router} />
        </QueryClientProvider> 
    </WagmiProvider>
  );
}

export default App;
